/** Percent of the context window in use (0–100), rounded; null if unknown or limit is 0. */
export function ctxFillPct(used: number | null, limit: number | null): number | null {
  if (used === null || limit === null || limit <= 0) return null;
  return Math.min(100, Math.round((used / limit) * 100));
}

/** Token counts for display: abbreviated in thousands from 10k up, exact below. */
export function formatTokenCount(n: number): string {
  return n >= 10000 ? `${(n / 1000).toFixed(1)}k` : String(n);
}
